<template>
  <div class="pt-4 py-16">
    <div v-if="getCart.length !== 0" class="lg:flex">
      <div class="flex-row pt-3 lg:w-4/6 sm:flex-col sm:w-full">
        <div v-if="getCart.length !== 0">
          <!-- {{$t('EmptyCart')}}! -->
        </div>
        <!-- Product cart -->
        <div class="flex-wrap">
          <h3 class="text-2xl text-gray-900 pb-10 w-5/6 align-470-titulli-shporta">Dein Warenkorb</h3>

          <div class="shporta">

          <ul class="disaply-new-grid">
            <li>Produkt:</li>
            <li>Preis:</li>
            <li>Menge:</li>
            <li>Lieferung:</li>
            <li class="shporta-li"><i class="fa fa-trash"></i></li>
          </ul>
          <div
            class="max-w-sm pt-3 w-full lg:max-w-full lg:flex width-470-grid"
            v-for="item in getCart"
            :key="item.product_id"
          >
            <!-- <div
              class="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
            >
              <img class="object-cover" :src="item.img" alt="Product Cart Image" />
            </div>
            <div
              class="bg-white rounded-b lg:rounded-b-none lg:rounded-r px-4 flex flex-col justify-between leading-normal"
            >
              <div class>
                <p class="text-sm text-gray-600 flex items-center"></p>
                <div class="text-gray-700 font-semibold text-xl">
                  {{ item.product_name }}
                  <span class="text-base pl-5">
                    <button @click="action('clear',item)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </span>
                </div>
                <p class="text-teal-400 font-bold text-2xl">
                  {{ item.sale_price | formatNumber }}
                  <span
                    class="text-gray-700 text-base font-normal"
                  >Inkl. MwSt.</span>
                </p>
              </div>



              <div class="flex items-center">
                <div class="text-sm">
                  <span class="text-gray-700">
                    Lieferzeit:
                    <span class="text-teal-400">
                      <span v-if="item.stock > 0" class="text-teal-400 font-semibold">1-2 Wochen</span>
                      
                    </span>
                  </span>
                  <br />
                  <span class="text-gray-700">
                    Vom:
                    <span class="text-teal-400">{{item.shop_name}}</span>
                  </span>
                  <span>
                    <hr />
                    <p class="w-64 text-gray-700 text-sm">
                      Wir setzen uns mit dir in Verbindung,
                      um die genaue Lieferung nach Versand deines Artikels zu planen.
                    </p>
                  </span>
                  <div>
                    <button
                      class="bg-teal-400 px-5 py-1 text-white font-semibold rounded"
                      @click="action('add',item)"
                    >+</button>
                    <input
                      type="number"
                      name
                      value="1"
                      class="text-center text-teal-400 font-bold text-xl w-32"
                      v-model="item.qty"
                    />
                    <button
                      class="bg-teal-400 px-5 py-1 text-white font-semibold rounded"
                      @click="action('min',item)"
                    >-</button>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="width-produkti"> 

              <div class="width-img">  
              <img class="object-cover shporta-img" :src="item.img" alt="Product Cart Image" style="border-radius: 5px; margin-top: 12px;"/>
            </div>   
            <div class="width-titulli-name">  
              <p class="titulli-style-new"> {{ item.product_name }}</p>
            </div>

            </div>

            <div class="qmimi-430">
            <p class="text-teal-400 font-bold new-text-qmimi">
                  {{ item.sale_price | formatNumber }}
                </p>
                <div class="sasia-style  button-max-width">
          <button
            class="numri-new-plus"
            @click="action('add',item)"
          >
            +
          </button>
          <input
            class="text-center font-bold text-1xl text-teal-400 new-width numri-new"
            min="1"
            value="1"
            name
            v-model="item.qty"
          />
          <button
            class="numri-new-minus"
            @click="action('min',item)"
          >
            -
          </button>
        </div>
        <div class="trash-style display-430-shporta2">
              <button @click="action('clear',item)">
                      <i class="fa fa-trash"></i>
                    </button>
            </div>
            </div>

        <div class="sasia-style display-430">
          <button
            class="numri-new-minus"
            @click="action('min',item)"
          >
            -
          </button>
          <input
            class="text-center font-bold text-1xl text-teal-400 new-width numri-new"
            min="1"
            value="1"
            name
            v-model="item.qty"
          />
          <button
            class="numri-new-plus"
            @click="action('add',item)"
          >
            +
          </button>
        </div>
           
            <div class="ship-style">
              <span class="text-gray-700 text-base font-normal new-text-size-ship">Inkl. MwSt.</span>
              <span class="text-gray-700 new-text-size-ship-light">
                    Lieferzeit:
                    <span class="text-teal-400 new-text-size-ship-light">
                      <span v-if="item.stock > 0" class="text-teal-400 font-semibold new-text-size-ship">1-2 Wochen</span>
                      
                    </span>
                  </span>
                  <br />
                  <span class="text-gray-700 new-text-size-ship">
                    Vom:
                    <span class="text-teal-400 new-text-size-ship">{{item.shop_name}}</span>
                  </span>
                  <span>
                    <hr />
                    <p class="w-64 text-gray-700 text-sm new-text-size-ship new-text-size-ship-light">
                      Wir setzen uns mit dir in Verbindung,
                      um die genaue Lieferung nach Versand deines Artikels zu planen.
                    </p>
                  </span>
            </div>
            <div class="trash-style display-430-shporta">
              <button @click="action('clear',item)">
                      <i class="fa fa-trash"></i>
                    </button>
            </div>

          </div>
          <div class="mt-6">
            <div class="border-t w-5/6">
              <p class="text-sm text-gray-900">Artikel im Warenkorb werden nicht reserviert.</p>
            </div>
          </div>
        </div>
      </div>
        <!-- /Product cart -->
      </div>
      <!-- Product info -->
      <div class="flex-wrap pt-3 lg:w-2/6 sm:w-full">
        <h3 class="text-2xl text-gray-900 border-b mt-3 p-3">Bestellübersicht</h3>
        <!-- <p class="pt-3 text-gray-900">
          <span class="font-semibold">Gutscheincodes</span>
          können im letzten Bestellschritt “Bestätigen” eingelöst werden.
        </p> -->
        <div class="bg-gray-200 p-2 mt-3">
          <div class="pt-3 w-full">
            <p class="pl-2 text-sm">
              Zwischensumme
              <span class="float-right">{{ total | formatNumber }}</span>
            </p>
            <p class="pl-2 text-sm">
              Versand kostelnos
              <span class="float-right">0,00 €</span>
            </p>
            <hr />
          </div>
          <h1 class="text-xl w-full p-2">
            Gesamtbetrag
            <span class="float-right text-teal-400">{{ total | formatNumber }}</span>
          </h1>
          <div class="w-full p-2">
            <span class="text-md">
              inkl. MwSt.
              <span class="float-right">{{ total * 0.19 | formatNumber }}</span>
            </span>
          </div>
          <div class="w-full p-2">
            <router-link
              to="/checkout"
              class="bg-teal-400 block text-center font-semibold text-white px-16 py-2 rounded hover:text-teal-400 hover:bg-white"
            >Zur Kasse gehen</router-link>
          </div>
        </div>
        <div class="pt-8">
          <span class="text-xs text-gray-900">
            <i class="fa fa-undo"></i>
            14 TAGE RÜCKGABERECHT
          </span>
        </div>
        <div>
          <span class="text-xs text-gray-900">
            <i class="fa fa-truck"></i>
            KOSTENLOSER VERSAND & RÜCKVERSAND
          </span>
        </div>
      </div>
      <!-- /Product info -->
    </div>
    <div v-else>
      <EmptyCart />
    </div>
    <div class="pt-3">
      <router-link to="/">
        <span
          class="bg-teal-400 text-white mt-10 px-6 py-2 font-semibold rounded hover:bg-white hover:text-teal-400"
        >
          <i class="fa fa-arrow-left w-6 h-6 pt-2"></i>
          Zurück zum Einkaufen
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EmptyCart from "./EmptyCart";

export default {
  components: {
    EmptyCart,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getCart"]),
    // cart() {
    //   return this.$store.getters.getCart;
    // },
    total() {
      let som = 0;
      this.getCart.map((item) => {
        som += item.sale_price;
      });
      return som;
    },
  },
  methods: {
    action(event, item) {
      switch (event) {
        case "add":
          item.qty++;
          item.sale_price = item.amount * item.qty;

          // console.log(item.qty);
          this.$store.commit("setQuantity", item);
          this.$store.commit("setPrice", item);
          localStorage.setItem("cart", JSON.stringify(this.getCart));
          break;
        case "min":
          item.qty--;
          item.sale_price = item.amount * item.qty;
          this.$store.commit("setQuantity", item);
          this.$store.commit("setPrice", item);
          localStorage.setItem("cart", JSON.stringify(this.getCart));
          if (item.qty === 0) this.clearFromCart(item);
          break;
        case "clear":
          this.clearFromCart(item);
          break;
        default:
          break;
      }
    },
    clearFromCart(product) {
      let item= this.getCart.find((item) => {
        return item.shopmarketplace_id === product.shopmarketplace_id;
      });
      let index = this.getCart.indexOf(item);
      this.getCart.splice(index, 1);
      localStorage.setItem("cart", JSON.stringify(this.getCart));
    },
  },
};
</script>

<style>


.shporta-li{
      margin-left: 7px;
}

.shporta{
  
      margin-right: 10px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.disaply-new-grid {
  display: grid;
  grid-template-columns: 4fr 2fr 3fr 2fr 1fr;
   grid-template-rows: 1fr;
   padding-bottom: 10px;
   border-bottom: 1px solid rgb(228, 228, 228);
}

.width-470-grid{
  padding-top: 20px;
  display: grid;
  grid-template-columns: 4fr 1.2fr 2fr 2fr 1fr;
  border-bottom: 1px solid rgb(228, 228, 228);
  padding-bottom: 10px;
  /* height: 200px; */
  
}

.width-produkti{
  width: 100%;
  /* height: 100px; */
  max-height: 80px;
 display: flex;
 flex-direction: row;
 gap: 10px;
 
}

.width-img{
  margin-left: 5px;
  flex: 1;
}

.width-titulli-name{
  flex: 3;
}

.titulli-style-new{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;

  letter-spacing: 0.2px;
  font-size: 14px;
  padding: 5px;
}

.amount-style{
  display: flex;
}

.numri-new-plus{
    border: 1px solid rgb(222, 221, 221);
    padding: 0 11px;
  }
  .numri-new-minus{
    border: 1px solid rgb(222, 221, 221);
    padding: 0 11px;
  }
  .numri-new{
    border: 1px solid rgb(222, 221, 221);
    color: #4c4c4c !important;


  }

  .button-max-width{
    display: none !important;
  }

  .sasia-style{
    display: flex;
    padding: 0 10px;
    width: 50%;
    height: 28px;

  }

  .new-width{
    width: 3rem;
  }

  .display-430-shporta2{
    display: none !important;
  }

  .ship-style{
    display: flex;
    flex-direction: column;
  }

  .trash-style{
    padding-left: 5px;
  }

  .new-text-size-ship{
    font-size: 14px;
  }
  .new-text-size-ship-light{
    font-size: 12px;
  }

  .new-text-qmimi{
    font-size: 14px;
  }

  @media (max-width:470px) {
    .disaply-new-grid{
      display: none;
    }

    .width-470-grid{
      display: flex;
      flex-direction: column;
    }
    .align-470-titulli-shporta{
      text-align: center;
      width: 100%;
      font-size: 18px;
      font-weight: 500;
    }
   
  }

  @media (max-width:470px) {
    .width-img{
      margin-left: 0;
    }

     .width-produkti{
      max-height: 76px !important;
    }
    .titulli-style-new{
      font-size: 12px;
    }
    .shporta-img{
      width: 80%;
      margin-top: 5px  !important;
    }
    .qmimi-430{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      justify-content: space-between;
    }
    .display-430{
      display: none;
    }
    .button-max-width{
    display: block !important;
  }
  .display-430-shporta{
    display: none !important;
  }

  .display-430-shporta2{
    display: block !important;
  }
  .width-470-grid{
    margin-bottom: 20px;
  }
  }

  /* @media (max-width:430px) {

    .width-img{
      margin-left: 0;
    }

     .width-produkti{
      max-height: 76px !important;
    }
    .titulli-style-new{
      font-size: 12px;
    }
    .shporta-img{
      width: 80%;
      margin-top: 5px  !important;
    }
    .qmimi-430{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      justify-content: space-between;
    }
    .display-430{
      display: none;
    }
    .button-max-width{
    display: block !important;
  }
  .display-430-shporta{
    display: none !important;
  }

  .display-430-shporta2{
    display: block !important;
  }
  .width-470-grid{
    margin-bottom: 20px;
  }
  } */

</style>